import React from 'react';

import styles from './CreateCalculationModal.scss';

export const ConditionalIcon = (props) => (
  <svg className={styles.cardIcon} viewBox="0 0 32 32" {...props}>
    <path d="M0,0V32H32V0ZM12.41,23.75,5,27V25.15l5-2-5-2V19.27l7.41,3.25Zm0-16.9-5,2,5,2v1.85L5,9.48V8.25L12.41,5ZM27,22.5H24.67l-.61,1.59H27v1.6H23.51l-.82,2.23H20.81l.83-2.23H19.93v-1.6h2.25l.62-1.59H19.93V20.9h3.41l1-2.55h1.87l-1,2.55H27Zm0-11.24H20V9.66H27Zm0-3.19H20V6.47H27Z" />
  </svg>
);
